import { webMiniGaugeClassName } from '@emovia/design-system';
import { CircularProgress } from '@/components/ui/circular-progress';
import { cn } from '@/lib/utils';

type MiniGaugeProps = {
  value: number;
  label: string;
  className?: string;
};

export function MiniGauge({ value, label, className }: MiniGaugeProps) {
  const resolved = webMiniGaugeClassName();
  const slots = typeof resolved === 'string' ? { root: resolved, label: '' } : resolved;

  return (
    <div className={cn('inline-flex', slots.root, className)}>
      <CircularProgress
        value={value * 10}
        size="sm"
        formatValue={(val) => String(Math.round(val / 10))}
      />
      <small className={slots.label}>{label}</small>
    </div>
  );
}
